module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-grey-4-366eccdaf6f339e99c76e9b220d17da6.png";